"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOCK_SITE_ADDRESS = void 0;
exports.MOCK_SITE_ADDRESS = {
    unitNumber: '101',
    streetNumber: '408',
    streetType: 'Street',
    streetName: 'Lonsdale',
    suburb: 'MELBOURNE',
    state: 'VIC',
    postcode: '3000',
    deliveryPointId: '66199012',
    longitude: '144.96040233',
    latitude: '-37.81259809',
    isValidated: 'false',
};
//# sourceMappingURL=site-address.mock.js.map